export const SEARCH_DEBOUNCE_MS = 400;
export const PAGINATION_FOCUS_DEBOUNCE_MS = 250;
